<template>
  <div>
    <a-row :gutter="20">
      <a-col :span="16">
        <a-select
          mode="multiple"
          style="width: 100%"
          @change="$emit('input', $event)"
          :value="value"
          placeholder="请选择"
          @focus="focus"
          :filterOption="filterOption"
          optionFilterProp="children"
        >
          <a-select-option v-for="item in tagList" :value="item.id" :key="item.id">{{ item.title }}</a-select-option>
        </a-select>
      </a-col>
      <a-col :span="7">
        <a-button type="primary" @click="showNewTagModal = true">添加标签</a-button>
      </a-col>
    </a-row>
    <a-modal
      title="添加新标签"
      :visible="showNewTagModal"
      @ok="onAddNewTag"
      @cancel="showNewTagModal = false"
      okText="确认"
      cancelText="取消"
    >
      <a-input placeholder="请输入添加的标签名称" v-model="newTag" />
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'Lable',
  props: {
    value: { type: Array, default: () => [] }
  },
  data() {
    return {
      tagList: [],
      showNewTagModal: false,
      newTag: '',
      searchText: ''
    }
  },
  async mounted() {
    this.focus()
  },
  methods: {
    async focus() {
      this.tagList = await this.$http.get('/p/material/web/matTag/options')
    },
    async onAddNewTag() {
      if (this.newTag === '') {
        this.$error({
          title: '错误',
          content: '输入不能为空'
        })
        return false
      }
      const newTagItem = await this.$http.post('/p/material/web/matTag', {
        title: this.newTag,
        state: 1,
        seq: 0
      })
      if (newTagItem.code === '0') {
        this.$error({
          title: '错误',
          content: newTagItem.message
        })
        return
      }
      this.tagList.push(newTagItem)
      this.$emit('input', [...this.value, newTagItem.id])
      this.newTag = ''
      this.showNewTagModal = false
    },
    handleChange(value) {
      console.log(value)
    },
    filterOption(input, option) {
      console.log(input, option)
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>
